module.exports = {"id":"225126","name":"Ellyes Skhiri","rating":"74","photo":"./data/images/photos/2/225126.png","club":{"name":"Montpellier HSC","logo":"./data/images/clubs/MontpellierHSC.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/EllyesSkhiri0.json
// module id = 1208
// module chunks = 0